import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import { OrdersProvider } from "./context/OrdersContext";
import { DisplayConfigProvider } from "./context/DisplayConfigContext";
import ActiveOrders from "./pages/ActiveOrders";
import CompletedOrders from "./pages/CompletedOrders";
import LandingPage from "./pages/LandingPage";

// Wrapper so each display URL gets its own fresh OrdersProvider instance.
// The key prop forces a full remount when navigating between displays.
function ActiveOrdersRoute() {
  const { type } = useParams();
  return (
    <OrdersProvider key={type}>
      <ActiveOrders />
    </OrdersProvider>
  );
}

export default function App() {
  return (
    <DisplayConfigProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/active/:type" element={<ActiveOrdersRoute />} />
          <Route path="/completed/:type" element={<CompletedOrders />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </DisplayConfigProvider>
  );
}
